import { render, staticRenderFns } from "./DinnerZeropointDetails.vue?vue&type=template&id=2f68f1b7&scoped=true&"
import script from "./DinnerZeropointDetails.vue?vue&type=script&lang=js&"
export * from "./DinnerZeropointDetails.vue?vue&type=script&lang=js&"
import style0 from "./DinnerZeropointDetails.vue?vue&type=style&index=0&id=2f68f1b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f68f1b7",
  null
  
)

export default component.exports